/**
 * User requests
 */
import API from '@/api/base.js';
export default {

    initSession(){
        return API.get('/session',{},'Session',false);
    },
    login(credentials){
        return API.post('/session',credentials,'Login');
    },
    register(data){
        return API.post('/user',data,'Register');
    },
    getUserById(id,data){
        return API.get(`/user/${id}`,data,'Get');
    },
    getStripeLoginLink(id){
        return API.get(`/user/${id}/stripe/loginLink`,{},'Stripe login link');
    },
    updateUser(data){
        let id=(data)?data.id:null;
        return API.post(`/user/${id}`,data,'Update');
    },
    changePassword(data){
        return API.post(`/user/password`,data,'Change password');
    },
    logout(){
        return API.delete('/session',{},'Logout');
    }
}
